import { CircularProgress, Dialog, DialogContent } from "@material-ui/core";
import React from "react";

import useStyles from "./styles";

interface DialogWaitingConfirm {
  onClose?: () => void;
  open: boolean;
}

const DialogWaitingConfirm: React.FC<DialogWaitingConfirm> = ({ open }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} className={classes.root} fullWidth maxWidth="xs">
      <DialogContent className={classes.dialogContent}>
        <CircularProgress size={29} style={{ color: "#009FB8" }} />
        <p className={classes.titleHeader}>ระบบกำลังดำเนินการ</p>
        <p className={classes.description}>
          กรุณารอสักครู่ / โปรดอย่ากด Refresh หรือปิดหน้าจอ
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default DialogWaitingConfirm;
